import { render, staticRenderFns } from "./CategoryDesc.vue?vue&type=template&id=cb4bfb5a&"
import script from "./CategoryDesc.vue?vue&type=script&lang=js&"
export * from "./CategoryDesc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports